import colors from "./colors.module.scss";

type StyleType = {
  white_0: string;
  orange_900: string;
  orange_800: string;
  orange_700: string;
  orange_600: string;
  orange_500: string;
  orange_400: string;
  orange_300: string;
  orange_200: string;
  orange_100: string;
  orange_50: string;
  blue_900: string;
  blue_800: string;
  blue_700: string;
  blue_600: string;
  blue_500: string;
  blue_400: string;
  blue_300: string;
  blue_200: string;
  blue_100: string;
  blue_50: string;
  green_900: string;
  green_800: string;
  green_700: string;
  green_600: string;
  green_500: string;
  green_400: string;
  green_300: string;
  green_200: string;
  green_100: string;
  green_50: string;
  yellow_900: string;
  yellow_800: string;
  yellow_700: string;
  yellow_600: string;
  yellow_500: string;
  yellow_400: string;
  yellow_300: string;
  yellow_200: string;
  yellow_100: string;
  yellow_50: string;
  red_900: string;
  red_800: string;
  red_700: string;
  red_600: string;
  red_500: string;
  red_400: string;
  red_300: string;
  red_200: string;
  red_100: string;
  red_50: string;
  gray_900: string;
  gray_800: string;
  gray_700: string;
  gray_600: string;
  gray_500: string;
  gray_400: string;
  gray_300: string;
  gray_200: string;
  gray_100: string;
  gray_50: string;
  gray_0: string;
  schema_primary_main: string;
  schema_primary_light: string;
  schema_secondary_main: string;
  schema_secondary_light: string;
  schema_background_main: string;
  schema_background_light: string;
  schema_surface_main: string;
  schema_surface_light: string;
  schema_surface_disable: string;
  schema_negative_main: string;
  schema_negative_light: string;
  schema_positive_main: string;
  schema_positive_light: string;
  schema_warning_main: string;
  schema_warning_light: string;
  schema_constant_main: string;
  foreground_primary_he: string;
  foreground_primary_me: string;
  foreground_primary_le: string;
  foreground_secondary_he: string;
  foreground_secondary_me: string;
  foreground_background_he: string;
  foreground_background_me: string;
  foreground_background_disable: string;
  foreground_surface_he: string;
  foreground_surface_me: string;
  foreground_surface_disable: string;
  foreground_negative_he: string;
  foreground_negative_me: string;
  foreground_positive_he: string;
  foreground_positive_me: string;
  foreground_warning_he: string;
  foreground_warning_me: string;
  foreground_outline_darker: string;
  foreground_outline_lighter: string;
};

const ColorSchema: StyleType = {
  white_0: colors.white_0,
  orange_900: colors.orange_900,
  orange_800: colors.orange_800,
  orange_700: colors.orange_700,
  orange_600: colors.orange_600,
  orange_500: colors.orange_500,
  orange_400: colors.orange_400,
  orange_300: colors.orange_300,
  orange_200: colors.orange_200,
  orange_100: colors.orange_100,
  orange_50: colors.orange_50,
  blue_900: colors.blue_900,
  blue_800: colors.blue_800,
  blue_700: colors.blue_700,
  blue_600: colors.blue_600,
  blue_500: colors.blue_500,
  blue_400: colors.blue_400,
  blue_300: colors.blue_300,
  blue_200: colors.blue_200,
  blue_100: colors.blue_100,
  blue_50: colors.blue_50,
  green_900: colors.green_900,
  green_800: colors.green_800,
  green_700: colors.green_700,
  green_600: colors.green_600,
  green_500: colors.green_500,
  green_400: colors.green_400,
  green_300: colors.green_300,
  green_200: colors.green_200,
  green_100: colors.green_100,
  green_50: colors.green_50,
  yellow_900: colors.yellow_900,
  yellow_800: colors.yellow_800,
  yellow_700: colors.yellow_700,
  yellow_600: colors.yellow_600,
  yellow_500: colors.yellow_500,
  yellow_400: colors.yellow_400,
  yellow_300: colors.yellow_300,
  yellow_200: colors.yellow_200,
  yellow_100: colors.yellow_100,
  yellow_50: colors.yellow_50,
  red_900: colors.red_900,
  red_800: colors.red_800,
  red_700: colors.red_700,
  red_600: colors.red_600,
  red_500: colors.red_500,
  red_400: colors.red_400,
  red_300: colors.red_300,
  red_200: colors.red_200,
  red_100: colors.red_100,
  red_50: colors.red_50,
  gray_900: colors.gray_900,
  gray_800: colors.gray_800,
  gray_700: colors.gray_700,
  gray_600: colors.gray_600,
  gray_500: colors.gray_500,
  gray_400: colors.gray_400,
  gray_300: colors.gray_300,
  gray_200: colors.gray_200,
  gray_100: colors.gray_100,
  gray_50: colors.gray_50,
  gray_0: colors.gray_0,
  schema_primary_main: colors.schema_primary_main,
  schema_primary_light: colors.schema_primary_light,
  schema_secondary_main: colors.schema_secondary_main,
  schema_secondary_light: colors.schema_secondary_light,
  schema_background_main: colors.schema_background_main,
  schema_background_light: colors.schema_background_light,
  schema_surface_main: colors.schema_surface_main,
  schema_surface_light: colors.schema_surface_light,
  schema_surface_disable: colors.schema_surface_disable,
  schema_negative_main: colors.schema_negative_main,
  schema_negative_light: colors.schema_negative_light,
  schema_positive_main: colors.schema_positive_main,
  schema_positive_light: colors.schema_positive_light,
  schema_warning_main: colors.schema_warning_main,
  schema_warning_light: colors.schema_warning_light,
  schema_constant_main: colors.schema_constant_main,
  foreground_primary_he: colors.foreground_primary_he,
  foreground_primary_me: colors.foreground_primary_me,
  foreground_primary_le: colors.foreground_primary_le,
  foreground_secondary_he: colors.foreground_secondary_he,
  foreground_secondary_me: colors.foreground_secondary_me,
  foreground_background_he: colors.foreground_background_he,
  foreground_background_me: colors.foreground_background_me,
  foreground_background_disable: colors.foreground_background_disable,
  foreground_surface_he: colors.foreground_surface_he,
  foreground_surface_me: colors.foreground_surface_me,
  foreground_surface_disable: colors.foreground_surface_disable,
  foreground_negative_he: colors.foreground_negative_he,
  foreground_negative_me: colors.foreground_negative_me,
  foreground_positive_he: colors.foreground_positive_he,
  foreground_positive_me: colors.foreground_positive_me,
  foreground_warning_he: colors.foreground_warning_he,
  foreground_warning_me: colors.foreground_warning_me,
  foreground_outline_darker: colors.foreground_outline_darker,
  foreground_outline_lighter: colors.foreground_outline_lighter,
};

export default ColorSchema;
